import type { S3File } from '../../../utils'
import type { BLOCK_TYPE } from '../enums'

import type { BlockBaseSettings, IBlock } from './base'

/**
 * Which file types are supported for upload
 *
 * NOTE: These should map to `supported-file-types` in the translation files
 * associated with the Journey Builder.
 *
 * TODO: Make values lowercase
 */
export enum UPLOAD_FILE_TYPES {
  IMAGE = 'Image',
  TEXT = 'Text',
  PDF = 'PDF',
  SHEET = 'Sheet',
  PRESENTATION = 'Presentation',
  AUDIO = 'Audio',
  VIDEO = 'Video',
  ARCHIVES = 'Archives',
  MAIL = 'Mail',
  CAD = 'Cad'
}

export interface UploadBlock extends IBlock {
  type: BLOCK_TYPE.FILE_UPLOAD
  settings: BlockBaseSettings & {
    /**
     * The maximum number of files that can be uploaded
     * If set to 0 (zero), it means an unlimited number of files can be uploaded
     */
    maxQuantity: number
    /** Whether the supported file types are restricted */
    restricted?: boolean
    /** Which file types are supported */
    supportedTypes?: UPLOAD_FILE_TYPES
    /** Tags to be associated with the uploaded files */
    tags?: string[]
    /** Which message to display within the upload zone */
    zoneLabel?: string
  }
}

export type UploadBlockValue = S3File[]
